import script from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=5b650943&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/api2-production/workspace/api2/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b650943"]])

export default __exports__